import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import MarkdownView from "@/components/MarkdownView";
import Mermaid from "@/components/Mermaid";
import { Target, GitBranch, Grid3x3, TrendingDown, Rocket } from "lucide-react";

const SECTION_META = [
  { key: "diagnostic", icon: Target, accent: "#8B5CF6", labelKey: "result.diagnostic" },
  { key: "mermaid", icon: GitBranch, accent: "#3B82F6", labelKey: "result.mermaid" },
  { key: "matrix", icon: Grid3x3, accent: "#EAB308", labelKey: "result.matrix" },
  { key: "finance", icon: TrendingDown, accent: "#F59E0B", labelKey: "result.finance" },
  { key: "strategy", icon: Rocket, accent: "#10B981", labelKey: "result.strategy" },
];

export default function ReportSections({ sections }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      {SECTION_META.map((meta, i) => {
        const content = sections?.[meta.key];
        if (!content) return null;
        const Icon = meta.icon;
        return (
          <motion.section
            key={meta.key}
            data-testid={`section-${meta.key}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: i * 0.08 }}
            className="rounded-xl bg-[#151A22] border border-border overflow-hidden"
          >
            <div className="flex items-center gap-3 px-6 py-4 border-b border-border bg-white/[0.015]">
              <div className="h-9 w-9 rounded-lg flex items-center justify-center" style={{ background: `${meta.accent}1f`, border: `1px solid ${meta.accent}55` }}>
                <Icon className="h-4.5 w-4.5" style={{ color: meta.accent }} />
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground">{t(meta.labelKey)}</h3>
            </div>
            <div className="p-6">
              {meta.key === "mermaid" ? <Mermaid chart={content} /> : <MarkdownView>{content}</MarkdownView>}
            </div>
          </motion.section>
        );
      })}
    </div>
  );
}
